import api from '../api'

//data
const state = {
  status:{
    loading:false,
    loaded:false,
    error:'', // last error
    lastLoaded:''
  },
  items:{

  },

  searchTerm:'', //used in category menu search
  selectedCategory:{
    category:'',
    categorya:'',
    categoryb:'',
	categoryLink:'',
	categoryaLink:'',
	categorybLink:''
  }
}

//comuted store.getters.inCart
const getters = {

}

//sync methods store.commit('increment')
const mutations = {
  SET_CATEGORY (state, data) {
    state.items = data;
	state.status.loaded = true;
  },
  SET_SELECTED_CATEGORY (state, data) {
    state.selectedCategory.category = data.category;
    state.selectedCategory.categorya = data.categorya;
    state.selectedCategory.categoryb = data.categoryb;
    state.selectedCategory.categoryLink = data.categoryLink;
    state.selectedCategory.categoryaLink = data.categoryaLink;
    state.selectedCategory.categorybLink = data.categorybLink;
  },
  SET_CATEGORY_SEARCH_TERM (state, data) {
    state.searchTerm = data
  },
}

//async methods  store.dispatch('increment')
const actions = {
  loadCategory ({state, commit}) {
    return api.get('category')
      .then(function (response) {
		//console.log(response.data.items);
		commit('SET_CATEGORY', response.data.items);
      })
      .catch(function(error) {});
  },
}

export default {
  state, mutations, actions, getters
}



// WEBPACK FOOTER //
// ./src/store/modules/CategoryStore.js